import React from 'react'

export default function Title(props) {
  return (
    <h1>{props.text}</h1>
  )
}
